<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0" >
        <span @click="$router.go(-1)" >
          <b-button
              variant="white"
              class="btn-icon rounded-circle mr-50 text-danger bg-white"
              size="sm"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span> Crear departamento
      </h2>
    </div>
    <b-card>
      <!-- form -->
      <validation-observer ref="createDepartment">
        <b-form
            @submit.prevent="handleSubmit"
            @keydown.enter="handleSubmit"
        >
          <b-row>
            <b-col sm="6" >
              <validation-provider
                  #default="{ errors }"
                  :name="'Nombre'"
                  rules="required"
              >
                <b-form-group
                    :label="'Nombre'"
                    label-for="department-name"
                >
                  <b-form-input
                      v-model="name"
                      name="name"
                      :placeholder="'Nombre'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6" >
              <validation-provider
                  #default="{ errors }"
                  :name="'Alias'"
                  rules="required"
              >
                <b-form-group
                    :label="'Alias'"
                    label-for="department-SKU"
                >
                  <b-form-input
                      v-model="SKU"
                      name="Alias"
                      :placeholder="'Alias'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  :name="'Tipo de medida'"
                  rules="required"
              >
                <b-form-group
                    :label="'Tipo de medida'"
                    label-for="type_measurements"
                >
                  <v-select
                      v-model="type_measurements"
                      label="label"
                      :filterable="false"
                      :searchable="false"
                      :options="selectTypeMeasurements"
                      :placeholder="'Tipo de medida'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="6" >
              <b-form-checkbox
                  v-model="active"
                  value="1"
              >
                Activo
              </b-form-checkbox>
            </b-col>
            <b-col cols="12" >
              <b-form-group
                  :label="'Descripción'"
                  label-for="department-description"
              >
                <quill-editor
                    :options="editorOption"
                    v-model="description"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12 text-right">
              <b-button
                  type="submit"
                  variant="primary"
                  class="mt-2 mr-1"
              >
                {{ 'Crear' }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import { quillEditor } from 'vue-quill-editor'
import vSelect from 'vue-select'
import quillMixin from "@/mixins/quillMixin"

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    quillEditor,
    vSelect
  },
  directives: {
    Ripple,
  },
  mixins: [quillMixin],
  data() {
    return {
      required,
      email,
      name: '',
      SKU: '',
      description: '',
      type_measurements: { value: 'no', label: 'No aplica' },
      active: false,
      selectTypeMeasurements: [
        { value: 'm2', label: 'm2' },
        { value: 'ml', label: 'ml' },
        { value: 'no', label: 'No aplica' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      currentClient: 'clients/getCurrentClient',
    }),
  },
  methods: {
    ...mapActions({
      create: 'departments/create',
    }),
    handleSubmit() {
      this.$refs.createDepartment.validate().then(success => {
        if (success) {
          const formData = this.createFormData()
          if (formData) {
            this.create({ department: formData })
          }
        }
      })
    },
    createFormData() {
      const data = new FormData()
      data.append('type_measurements', this.type_measurements.value)
      data.append('name', this.name)
      data.append('SKU', this.SKU)
      data.append('description', this.description)
      data.append('active', this.active)

      return data
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

